export default "__VITE_ASSET__Dzp8V3W___"